"use client";

import AdDetailModel from "@/models/AdDetailModel";
import { AD_IMAGE_RATIO } from "@/services/AdImageConfig";
import { Box, styled } from "@mui/material";
import ReactPlayer from "react-player";

const ReactPlayerWrapper = styled(Box)({
  position: "relative",
  paddingTop: `${AD_IMAGE_RATIO * 100}%`, // 16:9 aspect ratio
  ".react-player": {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
  },
});

export default function AdVideos({ ad }: { ad: AdDetailModel }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
      {/* AJB: convert shorts urls here or elsewhere */}
      {ad.videoUrls.map((url) => (
        <ReactPlayerWrapper key={url}>
          <ReactPlayer
            className="react-player"
            url={url}
            width="100%"
            height="100%"
            controls
            config={{
              file: {
                attributes: {
                  preload: "metadata",
                },
              },
            }}
          />
        </ReactPlayerWrapper>
      ))}
    </Box>
  );
}
